/* eslint-disable */
import { HANDLE_API_CALLS, LOGOUT_USER, CLEAR_STATE, HANDLE_API_CALLS_PARTNER ,HANDLE_SEED_API_CALLS, HANDLE_CREATE_API_CALLS, HANDLE_VM_LIST,HANDLE_VM_DETAILS, HANDLE_COHORTS_LIST, HANDLE_COHORTS_DETAILS ,  HANDLE_COHORTS_SEED_DATA, HANDLE_PATCH_COHORTS_BASIC, HANDLE_UPDATE_VM, HANDLE_UPLOAD_IMG_API, HANDLE_API_CALLS_CITY_DATA, HANDLE_DELETED_VM} from './constants';

export function getDataFromAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 



{
  return {
    type: HANDLE_API_CALLS,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function deleteVmApi(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 



{
  console.log("url",url)
  return {
    type: HANDLE_DELETED_VM,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function getCityDataFromAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 



{
  console.log("url",url)
  return {
    type: HANDLE_API_CALLS_CITY_DATA,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}


export function getvmListAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 

{

  console.log("getvmList action");
  
  return {
    type: HANDLE_VM_LIST,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}


export function getvmDetailsAPI(
  url,
  method,
  id,
  handleSuccess,
  handleError,
  showToast = false,
) 

{

  console.log("vm detailsaction",id);
  
  return {
    type: HANDLE_VM_DETAILS,
    url,
    method,
    id,
    handleSuccess,
    handleError,
    showToast,
  };
}


export function getCohortSeedDataAPI(
  url,
  method,
  handleSuccess,
  handleError,
  showToast = false,
) 

{

  console.log("-----Cohort Seed  DataAPI-------");
  
  return {
    type: HANDLE_COHORTS_SEED_DATA,
    url,
    method,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function getCohortListAPI(
  url,
  method,
  id,
  handleSuccess,
  handleError,
  showToast = false,
) 

{

  console.log("vm Cohorts--",id);
  
  return {
    type: HANDLE_COHORTS_LIST,
    url,
    method,
    id,
    handleSuccess,
    handleError,
    showToast,
  };
}



export function getCohortsDetailsAPI(
  url,
  method,
  id,
  handleSuccess,
  handleError,
  showToast = false,
) 

{

  console.log("get Cohorts details-",id);
  
  return {
    type: HANDLE_COHORTS_DETAILS,
    url,
    method,
    id,
    handleSuccess,
    handleError,
    showToast,
  };
}




export function getseedDataFromAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 

{
  
  return {
    type: HANDLE_SEED_API_CALLS,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function getvmListFromAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 

{
  
  return {
    type: HANDLE_VM_LIST,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function UploadImgAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 


{
  {console.log("UPLOAD")}
  
  return {
    type: HANDLE_UPLOAD_IMG_API,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function CreatevmAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) 


{
  {console.log("create api action")}
  
  return {
    type: HANDLE_CREATE_API_CALLS,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function getDataFromPartnerAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) {
  return {
    type: HANDLE_API_CALLS_PARTNER,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function PostcohortsbasicDataFromPartnerAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) {
  return {
    type: HANDLE_PATCH_COHORTS_BASIC,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}

export function UpdateVMDataFromPartnerAPI(
  url,
  method,
  body,
  handleSuccess,
  handleError,
  showToast = false,
) {
  return {
    type: HANDLE_UPDATE_VM,
    url,
    method,
    body,
    handleSuccess,
    handleError,
    showToast,
  };
}


export function logoutUser() {
  return {
    type: LOGOUT_USER,
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE,
  };
}


// WEBPACK FOOTER //
// ./src/Modules/HandleAPICalls/actions.js